import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTrash = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 25,
	height: 24,
	viewBox: "0 0 25 24",
	fill: "none",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M21.7344 6C21.7344 6.51284 21.3483 6.93551 20.851 6.99327L20.7344 7H19.8896L18.6582 19.5192C18.5198 20.9269 17.336 22 15.9214 22H8.54731C7.13278 22 5.94898 20.9269 5.81051 19.5192L4.57912 7H3.73438C3.18209 7 2.73438 6.55228 2.73438 6C2.73438 5.44772 3.18209 5 3.73438 5H8.73438C8.73438 3.067 10.3014 1.5 12.2344 1.5C14.1674 1.5 15.7344 3.067 15.7344 5H20.7344C21.2867 5 21.7344 5.44772 21.7344 6ZM14.4844 9.25C14.1047 9.25 13.7909 9.53215 13.7412 9.89823L13.7344 10V17L13.7412 17.1018C13.7909 17.4678 14.1047 17.75 14.4844 17.75C14.8641 17.75 15.1779 17.4678 15.2275 17.1018L15.2344 17V10L15.2275 9.89823C15.1779 9.53215 14.8641 9.25 14.4844 9.25ZM9.98438 9.25C9.60468 9.25 9.29088 9.53215 9.24122 9.89823L9.23438 10V17L9.24122 17.1018C9.29088 17.4678 9.60468 17.75 9.98438 17.75C10.3641 17.75 10.6779 17.4678 10.7275 17.1018L10.7344 17V10L10.7275 9.89823C10.6779 9.53215 10.3641 9.25 9.98438 9.25ZM12.2344 3.5C11.4059 3.5 10.7344 4.17157 10.7344 5H13.7344C13.7344 4.17157 13.0628 3.5 12.2344 3.5Z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgTrash);
export default ForwardRef;
